import { EKeyInitiativeGoalMode } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditorModal/helpers/keyInitiativeGoalMode'
import { TRANSLATION_KEYS as EDITOR_TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'

import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getGoalField, getInitiativeIncrementalField } from '../../helpers/fieldHelper'
import { TGroupedInitiativeRow } from '../models'

const GOAL_MODE_TRANSLATION_KEYS: Record<EKeyInitiativeGoalMode, string> = {
  [EKeyInitiativeGoalMode.RunRate]:
    EDITOR_TRANSLATION_KEYS.keyInitiativeEditor.goalFieldGroup.runRateMode,
  [EKeyInitiativeGoalMode.Incremental]:
    EDITOR_TRANSLATION_KEYS.keyInitiativeEditor.goalFieldGroup.incrementalMode,
  [EKeyInitiativeGoalMode.NoSalesTarget]: TRANSLATION_KEYS.dashboard.table.finGoalTypeNoSalesTarget,
}

export const getFinGoalTypeTranslationKey = (mode: EKeyInitiativeGoalMode): string =>
  GOAL_MODE_TRANSLATION_KEYS[mode]

export const getFinGoalValue = (
  item: TGroupedInitiativeRow,
  mode: EKeyInitiativeGoalMode,
  actualsType: ActualsValueTypes,
  activeCurrency: string
): number | null => {
  if (mode === EKeyInitiativeGoalMode.NoSalesTarget) {
    return null
  }

  const field =
    mode === EKeyInitiativeGoalMode.Incremental
      ? getInitiativeIncrementalField(actualsType, activeCurrency)
      : getGoalField(actualsType, activeCurrency)

  return item[field] ?? null
}
